import { PageLink } from 'models/PageLink';
import { determineProtocol } from './url-mapper';
import { Environment } from 'models/Environment';
import { buildCanonicalHref } from './buildCanonicalHref';
import { Domain } from 'models/domain';
import { buildDomainsForSubdomain } from 'helpers/buildDomainsForSubdomain';
import { FilterableQueryParams } from 'models/FilterableQueryParams';

/* istanbul ignore next */
function determineTrustedShopsSubdomainFromEnvironment(
  environment: Environment
) {
  switch (environment) {
    case 'production':
      return 'www';
    default:
      return environment;
  }
}

export const getAlternatePageLinksFromConfig = (
  environment: Environment,
  activeFilters: FilterableQueryParams
): PageLink[] => {
  const domains: Domain[] = buildDomainsForSubdomain(
    determineTrustedShopsSubdomainFromEnvironment(environment)
  );
  const protocol = determineProtocol();

  return domains.flatMap(({ domain, hreflang }) => {
    const host = domain;

    return {
      url: buildCanonicalHref(activeFilters, { host, protocol }),
      language: hreflang
    };
  });
};
